import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth } from '@workos-inc/authkit-react';
import { useEffect } from 'react';

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      state: (search.state as string) || undefined,
    };
  },
  component: Login,
});

function Login() {
  const { user, isLoading, signIn } = useAuth();
  const { state } = Route.useSearch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (user) {
        navigate({ to: state || '/dashboard' });
      } else {
        // Pass the state to WorkOS for post-auth redirect
        signIn({
          state: state || '/dashboard',
          organizationId: import.meta.env.VITE_WORKOS_DEFAULT_ORG_ID,
        });
      }
    }
  }, [isLoading, user, signIn, state, navigate]);

  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
}
